export class VehicleDetailModel
{
    VehicleRegistrationNo:string;
    VehicleType:number=0;
    VehicleMakeText:string;
    VehicleMake:number=0;
    YearOfRegistration:number;
    CardCount:string;
    VehicleTypeText:string;
    MappingId:number;
    IsMapped :boolean;
    CardId : number;
    CylinderNumber: string;
    HydroTest : string;
}





// WEBPACK FOOTER //
// ./src/app/models/VehicleDetailModel.ts